export default __webpack_public_path__ + "static/media/contact1.78c59aaa.png";